import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assests/logo.png';

const NAV_ITEMS = [
  { label: 'Home', path: '/' },
  { label: 'Help', path: '/help' },
  { label: 'Support', path: '/support' },
  { label: 'Privacy', path: '/privacy' },
  { label: 'Safety', path: '/safety' },
  { label: 'Terms', path: '/terms' },
];

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 border-b border-white/[0.06] bg-onyx/90 backdrop-blur-xl">
      <nav className="site-container flex h-[72px] items-center justify-between gap-4">
        <Link to="/" className="flex min-w-0 shrink-0 items-center gap-2.5" onClick={() => setMobileOpen(false)}>
          <img src={logo} alt="Strapin" className="h-9 w-9 shrink-0 object-contain" />
          <span className="truncate text-xl font-black tracking-tight text-white">
            Strap<span className="text-primary">in</span>
          </span>
        </Link>

        <ul className="hidden items-center gap-8 lg:flex">
          {NAV_ITEMS.map(({ label, path }) => (
            <li key={path}>
              <Link to={path} className={isActive(path) ? 'nav-link nav-link-active' : 'nav-link'}>
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 lg:flex">
          <button type="button" className="btn-primary !py-2.5 !text-xs" onClick={() => navigate('/download')}>
            Download App
          </button>
        </div>

        <button
          type="button"
          className="rounded-xl p-2 text-mist transition-colors hover:bg-white/10 lg:hidden"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            {mobileOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </nav>

      {mobileOpen && (
        <div className="border-t border-white/[0.06] bg-charcoal/95 px-6 py-4 lg:hidden">
          <div className="flex flex-col gap-1">
            {NAV_ITEMS.map(({ label, path }) => (
              <Link
                key={path}
                to={path}
                onClick={() => setMobileOpen(false)}
                className={`rounded-xl px-4 py-3 text-sm font-semibold ${
                  isActive(path) ? 'bg-primary/10 text-primary' : 'text-mist hover:bg-white/5'
                }`}
              >
                {label}
              </Link>
            ))}
            <button
              type="button"
              className="btn-primary mt-3 w-full"
              onClick={() => {
                setMobileOpen(false);
                navigate('/download');
              }}
            >
              Download App
            </button>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
